import { Injectable } from '@angular/core';
import { ExportType } from '@common/classes/export-type';
import { AppGridComponent } from '@common/components/app-grid/app-grid.component';
import { UploadActionButtonsComponent } from '@common/components/upload-action-buttons.component';
import { GridComponent } from '@progress/kendo-angular-grid';
import { NgxSpinnerService } from 'ngx-spinner';
import { QueryService } from './query.service';

@Injectable()
export class ExportService {
    constructor(
        private queryService: QueryService,
        public spinner: NgxSpinnerService
    ) {}

    public async export(
        exportType: ExportType,
        exportCommand: string,
        allData = false,
        appGrid: AppGridComponent,
        filter: any,
        selection: any[],
        commandData: any = null
    ) {
        const grid = appGrid.grid as GridComponent;
        const data: any = {
            columnDefs: grid.columns
                .toArray()
                .filter((x: any) => x.field)
                .map((x: any) => ({
                    header: x.displayTitle,
                    field: x.field
                })),
            exportType,
            query: filter ?? {},
            selectedIds: selection,
            ...commandData
        };
        if (allData === true) data.query.skip = data.query.take = 0;

        const exportMutation = this.queryService.getCommandMutation();
        this.spinner.show();
        return exportMutation
            .mutateAsync({ command: exportCommand, data })
            .then((res: any) => res && UploadActionButtonsComponent.download(res.fileName, res.content))
            .finally(() => this.spinner.hide());
    }
}
